"use client";

// src/spinner.tsx
import * as React from "react";
import {
  Base,
  systemForwardRef,
  useEmotionInstanceContext,
  useStyleConfig
} from "@stepstone-genesis/system";

// src/styles.ts
var root = {
  display: "inline-block",
  borderStyle: "solid",
  borderRadius: "radiusRound"
};
var variants = {
  default: {
    borderColor: "colorActionableLightDefault",
    borderTopColor: "colorActionableDefault"
  },
  inverted: {
    borderColor: "rgba(255, 255, 255, 0.2)",
    borderTopColor: "colorWhite"
  }
};
var smallBorderWidth = "2px";
var sizes = {
  small: {
    width: "size20",
    height: "size20",
    borderWidth: smallBorderWidth
  },
  medium: {
    width: "size30",
    height: "size30",
    borderWidth: `calc(${smallBorderWidth}*2)`
  },
  large: {
    width: "size60",
    height: "size60",
    borderWidth: `calc(${smallBorderWidth}*3)`
  },
  xl: {
    width: "size120",
    height: "size120",
    borderWidth: `calc(${smallBorderWidth}*5)`
  }
};
var styles = {
  root,
  variants,
  sizes
};

// src/spinner.tsx
var useRotateSpinner = () => {
  const { keyframes } = useEmotionInstanceContext();
  return keyframes({
    "0%": { transform: `rotate(0deg)` },
    to: { transform: `rotate(360deg)` }
  });
};
var Spinner = systemForwardRef(function Spinner2({
  variant = "default",
  a11yLabel = "Loading",
  size = "medium",
  isVisible = true,
  ...rest
}, ref) {
  const animation = useRotateSpinner();
  const { SPINNER } = useStyleConfig("SPINNER", {
    styles: {
      base: {
        ...styles.root,
        animation: `${animation} 0.6s linear infinite`,
        opacity: isVisible ? 1 : 0
      },
      responsiveVariants: [
        {
          id: "spinner-size",
          prop: size,
          variants: styles.sizes
        },
        {
          id: "spinner-variant",
          prop: variant,
          variants: styles.variants
        }
      ]
    }
  });
  return /* @__PURE__ */ React.createElement(
    Base,
    {
      ref,
      __themeDefinition: "spinner",
      "aria-label": a11yLabel,
      __root: SPINNER.styles,
      ...rest,
      role: "progressbar"
    }
  );
});
export {
  Spinner
};
